import { Record, List } from 'immutable';
import CurrencyUtilities from 'records/CurrencyUtilities';

const defaultValues = {
  id: 2,
  recipeName: '',
  costPerServing: 0,
  isSelected: false,
};

export default class MenuItemCostRecipe extends Record(defaultValues, MenuItemCostRecipe) {
  constructor(values) {
    super({
      ...values,
      costPerServing: values && values.costPerServing
            ? CurrencyUtilities.currencyFormat(values.costPerServing)
            : defaultValues.costPerServing,
    });
  }

  static getSelectedMenuItemCostRecipes(menuItemCostRecipes) {
    return menuItemCostRecipes.filter((item => {
      return item.get('isSelected') === true;
    }));
  }

  static getUnselectedMenuItemCostRecipes(menuItemCostRecipes) {
    return menuItemCostRecipes.filter((item => {
      return item.get('isSelected') === false;
    }));
  }

  static getMenuItemRecipeIndexById(menuItemCostRecipes, id) {
    return menuItemCostRecipes.findIndex(item => {
      return item.get('id') === id ? item : undefined;
    });
  }

  static mergeSelectedMenuItemCostRecipes(currentList, newList) {
    let mergedList = newList;
    const selectedItems = MenuItemCostRecipe.getSelectedMenuItemCostRecipes(currentList);
    selectedItems.forEach((item) => {
      const index = MenuItemCostRecipe.getMenuItemRecipeIndexById(newList, item.get('id'));
      if (index < 0) {
        mergedList = mergedList.push(item);
      }
    });
    return mergedList;
  }
}

export const MenuItemCostRecipes = (data) => {
  let menusItemCostRecipes = new List();
  if (data) {
    data.forEach((value) => {
      menusItemCostRecipes = menusItemCostRecipes.push(new MenuItemCostRecipe(value));
    });
  }
  return menusItemCostRecipes;
};
